import { mainSiteUrl } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-0 rounded-2xl overflow-hidden bg-foreground-950">
          <div className="w-full lg:w-2/5 relative">
            <div className="aspect-[3/4] lg:aspect-auto lg:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20smiling%20person%20sitting%20at%20modern%20cafe%20table%20with%20laptop%20and%20coffee%2C%20wearing%20casual%20fashionable%20outfit%20in%20olive%20green%20sweater%2C%20natural%20window%20light%20illuminating%20face%2C%20blurred%20cozy%20coffee%20shop%20interior%20background%2C%20authentic%20lifestyle%20portrait%20photography&width=600&height=800&seq=testimonial-v2-01&orientation=portrait"
                alt="Kakobuy Spreadsheet użytkownik"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5 p-8 md:p-12 lg:p-16 flex flex-col justify-center">
            <span className="text-6xl md:text-7xl font-heading text-accent-500 leading-none mb-4">"</span>
            <p className="text-lg md:text-xl text-background-50 leading-relaxed mb-6">
              Dzięki <strong>Kakobuy Spreadsheet</strong> zaoszczędziłem mnóstwo czasu na szukaniu produktów. Wszystko jest świetnie zorganizowane, kategorie są przejrzyste, a linki zawsze aktualne. To naprawdę najlepsza baza finds, z jakiej korzystałem.
            </p>
            <div className="mb-8">
              <p className="text-background-50 font-semibold text-sm">Marek K.</p>
              <p className="text-background-50/50 text-xs mt-0.5">Regularny użytkownik Kakobuy</p>
            </div>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-foreground-950 text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer w-fit"
            >
              Sprawdź moje finds
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}